import { TIME_RANGE } from '@nirvana/shared/constants';

export class ExecutiveSummaryDrillDownHelper {
  public static convertTimeRange(timeRange: TIME_RANGE) {
    switch (timeRange) {
      case TIME_RANGE.LAST_24_HOURS:
        return Constants.Network.lastSyncOptions.LAST_24_HOURS;
      case TIME_RANGE.LAST_7_DAYS:
        return Constants.Network.lastSyncOptions.LAST_7_DAYS;
      case TIME_RANGE.LAST_30_DAYS:
        return Constants.Network.lastSyncOptions.LAST_30_DAYS;
    }
  }
}
